module.exports = __webpack_public_path__ + "media/images/pc/page_common/banner/banner_costumes@3x-32c2d25aedbacc8a4743a3e1ff9717f0.webp";